import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "g-dialog-tips__footer"
}

import { reactive, watch, computed } from 'vue'
import { Dialog } from 'vant'
import { useNavigation } from '@mobile/router/navigation'
import { dialog } from '@/utils/vant'
import { useLogin } from '@/business/login'
import { useNoticeStore } from '@/stores'
import eventBus from '@/services/bus'
import Notify from '@mobile/components/base/notify/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { userLogout } = useLogin()
const { backHome } = useNavigation()
const noticeStore = useNoticeStore()

// 当前提示信息
const currentTipts = computed(() => noticeStore.tipsList[tips.index])

// 通知
const notify = reactive({
  show: false,
  title: '',
  content: ''
})

// 提示
const tips = reactive({
  show: false,
  index: 0
})

// 切换提示
const changeTips = (value: number) => {
  const i = tips.index + value
  if (i > -1 && i < noticeStore.tipsList.length) {
    tips.index = i
  }
}

watch(() => noticeStore.tipsList.length, (val) => {
  tips.index = 0
  tips.show = !!val
})

// 接收用户登出通知
eventBus.$on('LogoutNotify', (msg) => {
  userLogout(() => {
    if (msg) {
      dialog({
        message: msg as string,
        confirmButtonText: '确定'
      }).then(() => {
        backHome()
      })
    } else {
      backHome()
    }
  })
})

// 接收风控通知
eventBus.$on('RiskToWebNtf', (msg, type) => {
  const res = msg as { title: string, content: string }
  if (type === 1) {
    notify.title = res.title
    notify.content = res.content
    notify.show = true
  } else {
    dialog({
      title: res.title,
      message: res.content,
      confirmButtonText: '确定'
    })
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(Notify, {
      show: notify.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((notify.show) = $event)),
      title: notify.title,
      content: notify.content
    }, null, 8, ["show", "title", "content"]),
    _createVNode(_unref(Dialog), {
      class: "g-dialog-tips",
      show: tips.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((tips.show) = $event)),
      title: currentTipts.value?.title,
      theme: "round-button",
      "confirm-button-text": "关闭"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "g-dialog-tips__content",
          innerHTML: currentTipts.value?.content
        }, null, 8, _hoisted_1),
        (_unref(noticeStore).tipsList.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("span", {
                class: _normalizeClass({ disabled: tips.index === 0 }),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTips(-1)))
              }, "上一条", 2),
              _createElementVNode("span", {
                class: _normalizeClass({ disabled: tips.index === (_unref(noticeStore).tipsList.length - 1) }),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTips(1)))
              }, "下一条", 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}
}

})